// SATFeaturesScroll.js
import React from 'react';
import './featureScroll.css';

const features = [
  {
    id: 1,
    title: "Personalised SAT classes with",
    highlight: "top faculty",
    desc: "Our SAT faculty is highly specialised and great at what they do. From a batch size that never exceeds a 10:1 student-teacher ratio to individual test discussions, we personalise our training to perfection."
  },
  {
    id: 2,
    title: "Proctored SAT",
    highlight: "mock tests",
    desc: "Access to an advanced online learning portal with full-length and section-adaptive mock tests, class recordings, HD concept videos, score predictor and much more."
  },
  {
    id: 3,
    title: "SAT",
    highlight: "study material",
    desc: "We provide everything you need for your preparation, from printed materials and e-books to lab access at SAT centres."
  },
  {
    id: 4,
    title: "Check-ins,",
    highlight: "follow-ups",
    desc: "If you miss any class, expect a call from us. After your classes are over, expect a follow-up call from us to check on your progress."
  }
];

const FeaturesScroll = () => {
  // Duplicate content for seamless scrolling
  const repeatedFeatures = [...features, ...features];

  return (
    <div className="scroll-wrapper-1 py-5">
      <div className="scroll-track-1">
        <div className="scroll-content-1 d-flex">
          {repeatedFeatures.map((item, idx) => (
            <div key={idx} className="card mx-3 p-3 feature-card shadow-sm">
              <h5>
                {item.title} <span className="text-warning">{item.highlight}</span>
              </h5>
              <p className="text-muted">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturesScroll;
